export default "__VITE_ASSET__47ae4ee2__"